import { Avatar } from 'components/common/Avatar'
import { Flex } from 'primitives/Flex'

export const AvatarGroup = () => {
  return (
    <Flex>
      <Avatar
        css={{ cursor: 'pointer', backgroundImage: 'unset' }}
        status="active"
        size="xsmall"
        onClick={() => console.log('Clicked')}
        src="https://upload.wikimedia.org/wikipedia/commons/b/b2/Pinkcolor.JPG"
      />
      <Avatar
        css={{ cursor: 'pointer', backgroundImage: 'unset', right: '15px' }}
        status="active"
        size="xsmall"
        onClick={() => console.log('Clicked')}
        src="https://htmlcolorcodes.com/assets/images/colors/bright-green-color-solid-background-1920x1080.png"
      />
    </Flex>
  )
}
